var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSocketsCcsType1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.27,60.25a3.5,3.5,0,1,1,3.44-3.5A3.47,3.47,0,0,1,38.27,60.25Zm0-5.75a2.25,2.25,0,1,0,2.21,2.25A2.24,2.24,0,0,0,38.27,54.5Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.39,60.25a3.5,3.5,0,1,1,3.44-3.5A3.47,3.47,0,0,1,26.39,60.25Zm0-5.75a2.25,2.25,0,1,0,2.22,2.25A2.24,2.24,0,0,0,26.39,54.5Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.6,63.56A6.54,6.54,0,0,1,17.13,57v-.44a6.54,6.54,0,0,1,6.47-6.59H40.4a6.54,6.54,0,0,1,6.47,6.59V57a6.54,6.54,0,0,1-6.47,6.59Zm0-11.8a4.73,4.73,0,0,0-4.69,4.77V57a4.73,4.73,0,0,0,4.69,4.77H40.4A4.73,4.73,0,0,0,45.09,57v-.44a4.73,4.73,0,0,0-4.69-4.77Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4,50.23a6.26,6.26,0,0,1,6.19,6.3V57a6.25,6.25,0,0,1-6.19,6.3H23.6A6.24,6.24,0,0,1,17.41,57v-.44a6.25,6.25,0,0,1,6.19-6.3H40.4M23.6,62H40.4a5,5,0,0,0,5-5.06v-.44a5,5,0,0,0-5-5.05H23.6a5,5,0,0,0-5,5.05V57a5,5,0,0,0,5,5.06M40.4,49.66H23.6a6.81,6.81,0,0,0-6.75,6.87V57a6.81,6.81,0,0,0,6.75,6.87H40.4A6.82,6.82,0,0,0,47.15,57v-.44a6.82,6.82,0,0,0-6.75-6.87ZM23.6,61.46A4.45,4.45,0,0,1,19.19,57v-.44a4.45,4.45,0,0,1,4.41-4.48H40.4a4.45,4.45,0,0,1,4.41,4.48V57a4.45,4.45,0,0,1-4.41,4.49Z",
    fill: "#4f4e4f"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.39,
    cy: 56.75,
    rx: 1.22,
    ry: 1.24,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.27,
    cy: 56.75,
    rx: 1.22,
    ry: 1.25,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.16,24.14A23.16,23.16,0,1,0,26.28,46.59v2.29a2,2,0,0,0,.56,1.45,3.3,3.3,0,0,0,2.51.86h5.3a3.29,3.29,0,0,0,2.52-.87,1.92,1.92,0,0,0,.55-1.4V46.59A23,23,0,0,0,55.16,24.14ZM36.92,45.45l-.49.12V49a.75.75,0,0,1-.23.5,2.16,2.16,0,0,1-1.55.44h-5.3a2.17,2.17,0,0,1-1.55-.44.77.77,0,0,1-.23-.54V45.57l-.49-.12a21.87,21.87,0,1,1,9.84,0Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.65,52h-5.3a4,4,0,0,1-3.09-1.12,2.8,2.8,0,0,1-.76-2V47.2a23.94,23.94,0,1,1,13,0v1.73a2.72,2.72,0,0,1-.75,1.93A4,4,0,0,1,34.65,52ZM32,3.06a21.09,21.09,0,0,0-4.76,41.63l1.11.26v4a1.77,1.77,0,0,0,1,.19h5.3c.78,0,1-.2,1-.21V45l1.11-.26A21.09,21.09,0,0,0,32,3.06Z",
    fill: "#4f4e4f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.94,27.32a3.57,3.57,0,1,0,3.57,3.57A3.57,3.57,0,0,0,20.94,27.32Zm0,5.2a1.63,1.63,0,1,1,1.63-1.63A1.63,1.63,0,0,1,20.9,32.52Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.74,23.09A5.05,5.05,0,1,0,34.69,18,5.06,5.06,0,0,0,39.74,23.09Zm0-7.71A2.66,2.66,0,1,1,37.09,18,2.65,2.65,0,0,1,39.74,15.38Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.47,23.29A5.26,5.26,0,1,0,19.21,18,5.26,5.26,0,0,0,24.47,23.29Zm0-7.91A2.66,2.66,0,1,1,21.81,18,2.66,2.66,0,0,1,24.47,15.38Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.33,31.55a5.05,5.05,0,1,0,5.05,5.05A5,5,0,0,0,32.33,31.55Zm0,7.71A2.66,2.66,0,1,1,35,36.6,2.66,2.66,0,0,1,32.33,39.26Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.06,27.32a3.57,3.57,0,1,0,3.57,3.57A3.57,3.57,0,0,0,43.06,27.32ZM43,32.62a1.73,1.73,0,1,1,1.73-1.73A1.73,1.73,0,0,1,43,32.62Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,29.26a1.63,1.63,0,1,0,1.63,1.63A1.63,1.63,0,0,0,20.9,29.26Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,29.16a1.73,1.73,0,1,0,1.73,1.73A1.73,1.73,0,0,0,43,29.16Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,6.5A18.09,18.09,0,1,0,50.09,24.59,18.09,18.09,0,0,0,32,6.5ZM39.74,13a5,5,0,1,1-5.05,5A5,5,0,0,1,39.74,13Zm-15.27-.21A5.26,5.26,0,1,1,19.21,18,5.26,5.26,0,0,1,24.47,12.78ZM20.94,34.46a3.57,3.57,0,1,1,3.57-3.57A3.57,3.57,0,0,1,20.94,34.46Zm11.39,7.19a5,5,0,1,1,5.05-5A5,5,0,0,1,32.33,41.65Zm10.73-7.19a3.57,3.57,0,1,1,3.57-3.57A3.57,3.57,0,0,1,43.06,34.46Z",
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.33,
    cy: 36.6,
    r: 2.65,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.47,
    cy: 18.04,
    r: 2.65,
    fill: "#4f4e4f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.74,
    cy: 18.04,
    r: 2.65,
    fill: "#4f4e4f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSocketsCcsType1);
export default __webpack_public_path__ + "static/media/img_sockets_CCS_type_1.7cd4026354e6347391f7a0600a9e7a55.svg";
export { ForwardRef as ReactComponent };